import { Shuffle, ListOrdered, Bot } from "lucide-react";
import { Switch } from "@/components/ui/switch";

export const AutoDJPanel = ({ state, act }) => {
  const enabled = !!state?.autodj;
  const mode = state?.mode || "shuffle";
  const set = (patch) => act("put", "/studio/autodj", { enabled, mode, ...patch });
  return (
    <section className="panel p-5 flex flex-col gap-4" data-testid="studio-autodj-panel">
      <div className="flex items-center justify-between">
        <span className="eyebrow">Auto DJ</span>
        <span className={`font-mono text-xs tracking-widest ${enabled ? "text-[color:var(--green)]" : "text-[color:var(--lr-muted)]"}`} data-testid="studio-autodj-status">{enabled ? "RUNNING 24/7" : "STOPPED"}</span>
      </div>
      <label className="flex items-center justify-between rounded-xl bg-black/30 border border-white/10 p-4 cursor-pointer">
        <span className="flex items-center gap-3"><Bot className="w-6 h-6 text-[color:var(--cyan)]" /><span className="font-display text-2xl">Auto DJ rotation</span></span>
        <Switch checked={enabled} onCheckedChange={(v) => set({ enabled: v })} data-testid="studio-autodj-toggle" />
      </label>
      <div className="grid grid-cols-2 gap-2">
        {[["shuffle", "Shuffle", Shuffle], ["in_order", "In order", ListOrdered]].map(([v, label, Icon]) => (
          <button key={v} onClick={() => set({ mode: v })}
            className={`rounded-lg py-2.5 text-sm font-semibold flex items-center justify-center gap-2 border transition-colors ${mode === v ? "bg-[color:var(--gold)] text-black border-transparent" : "border-white/15 hover:bg-white/10"}`}
            data-testid={`studio-autodj-mode-${v}`}>
            <Icon className="w-4 h-4" /> {label}
          </button>
        ))}
      </div>
      <p className="text-xs text-[color:var(--lr-muted)]">
        Keeps the queue filled from your library ({state?.library_count ?? 0} tracks) and won't repeat a song too soon. Keeps playing when you close this tab.
      </p>
    </section>
  );
};
